import { Component } from "react";
import { FormattedMessage } from "react-intl";

import { LoadingIndicator } from "../shared/loading_indicator";

import { NotificationItem } from "./NotificationItem";

import type { GetNotificationsQuery } from "~/client/generated/schema";

interface Props {
  isLoaded: boolean;
  isError: boolean;
  notifications: GetNotificationsQuery["notifications"];
}

export class NotificationList extends Component<Props> {
  renderContents() {
    if (this.props.isError) {
      return (
        <li className="notificationCenter-notice">
          <FormattedMessage id="notifications.loadError" />
        </li>
      );
    } else if (this.props.notifications.nodes.length === 0) {
      return (
        <li className="notificationCenter-notice">
          <FormattedMessage id="notifications.messages.emptyNotification" />
        </li>
      );
    }

    return this.props.notifications.nodes.map((notification) => {
      return (
        <NotificationItem
          key={notification.id}
          sender={notification.sender}
          messageHtml={notification.messageHtml}
          updatedAt={notification.updatedAt}
          sourcePath={notification.sourcePath}
          state={notification.state}
        />
      );
    });
  }

  render() {
    return (
      <LoadingIndicator isLoaded={this.props.isLoaded || this.props.isError} top="50%" scale={0.3}>
        <ul className="notificationCenter-notifications">{this.renderContents()}</ul>
      </LoadingIndicator>
    );
  }
}
